<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirm800Function()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancel800Function()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="cancelHospitalModal" width="450" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-hospital-building</v-icon>
              <span class="modal-title-text mr-2">لغو بیمارستان</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-textarea dense outlined rows="5" clearable clear-icon="mdi-close-circle-outline" label="توضیحات"
                v-model="missionInformation.hospitalCancelReason" prepend-inner-icon="mdi-text mdi-18px"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="setCancelHospital()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSetCancelHospital()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="450" v-model="tenNineteenModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-ambulance mdi-flip-h</v-icon>
              <span class="modal-title-text mr-2">10-19</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="12">
              <v-autocomplete hide-details :items="allCancelReasonsForOther" no-data-text="اطلاعاتی وجود ندارد"
                tabindex="1" dense outlined clearable clear-icon="mdi-close-circle-outline" item-text="note"
                item-value="value" label="علل 19-10" :autofocus="true" v-model="editMissionSelectedCancleReason"
                autocomplete="off" prepend-inner-icon="mdi-ambulance mdi-18px"
                @change="setCancelReasonNote()"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea hide-details outlined prepend-inner-icon="mdi-text mdi-18px" clearable
                clear-icon="mdi-close-circle-outline" tabindex="2" label="توضیحات" rows="5"
                v-model="editMissionTenNineteenNote"></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-btn color="darkColor" @click="setCancelReasonFor800MissionFunction()" dark rounded block
                class="normal-letter-spacing">
                ثبت
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn rounded color="darkColor" outlined @click="cancelSetCancleReaonFor800Mission()"
                class="normal-letter-spacing px-10">انصراف از ثبت 19-10</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- <v-card-actions class=""> -->
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col cols="12">
        <!-- height="80vh" -->
        <v-card class="edit-mission-main-card">
          <v-row no-gutters>
            <v-col cols="12" class="modal-header py-5">
              <v-row no-gutters>
                <v-col cols="1">
                  <span class="phone-code">کد {{ phoneCode }}</span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" class="mt-3">
                  <v-row>
                    <span :class="editInfoTabClass" @click="changeTab('edit')">اطلاعات ماموریت</span>
                    <v-spacer></v-spacer>
                    <span :class="timeTabClass" @click="changeTab('time')">زمان ها و وضعیت</span>
                    <v-spacer></v-spacer>
                    <span :class="doctorInsideTabClass" @click="changeTab('doctor')">
                      دستورات پزشکی
                    </span>
                    <v-spacer></v-spacer>
                    <span :class="moreTabClass" @click="changeTab('moreInfo')">سایر اطلاعات</span>
                    <v-spacer></v-spacer>
                    <span :class="noteTabClass" @click="changeTab('note')">توضیحات</span>
                    <v-spacer></v-spacer>
                    <span :class="addressTabClass" @click="changeTab('address')">
                      سابقه آدرس و موقعیت جغرافیایی
                    </span>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="1" class="text-left mt-n2 ml-2">
                  <v-icon color="darkColor" @click="closeMissionEditModal()">mdi-close</v-icon>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-card-text class="mt-3">
            <v-row no-gutters>
              <v-col cols="12" v-if="editTab == 'edit'">
                <slot name="boxEdit">

                </slot>
              </v-col>
              <v-col cols="12" v-if="editTab == 'time'">
                <v-row>
                  <v-col cols="12" class="mb-9">
                    <v-row>
                      <span>زمان ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-n3">
                    <v-row>
                      <v-col v-for="item in missionTimes" :key="item.id" :cols="item.size">
                        <user-detail-component :clickable="false" has-icon v-if="item.title" :title="item.title"
                          :size="item.size" :text="item.text" :icon="item.icon" :per="item.per" :perKey="item.perKey"
                          :secondText="item.secondText"></user-detail-component>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-4">
                    <v-row>
                      <span class="mr-3">وضعیت ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="">
                    <edit-dialog-information-component v-if="editTab == 'time'" :tableHeader="stateDataTableHeader"
                      :tableItems="stateDataTableItems" :height="'30vh'"></edit-dialog-information-component>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'note'">
                <v-row>
                  <span>توضیحات</span>
                  <v-divider class="mt-2 mr-3"></v-divider>
                </v-row>
                <v-row>
                  <v-col cols="12" class="note-component-space mt-n4">
                    <v-row>
                      <v-col cols="12" v-for="item in noteList" :key="item.id" class="mb-5">
                        <dispatch-note-component :user="item.user" :date="item.date"
                          :note="item.note"></dispatch-note-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card elevation="0" height="17vh" class="note-box">
                      <v-row>
                        <v-col cols="2" class="not-box-title">
                          <span>افزودن توضیحات</span>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>

                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="12" class="note-box-input">
                          <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="11">
                              <v-textarea outlined prepend-inner-icon="mdi-text mdi-18px" rows="2"
                                @keydown="noteHandler" clearable clear-icon="mdi-close-circle-outline"
                                placeholder="توضیحات" v-model="noteText"></v-textarea>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                          <v-row>
                            <v-col cols="12" class="mt-n10">
                              <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="lightColor" @click="addNote()" class="ml-4 normal-letter-spacing" text>
                                  <v-icon color="lightColor">mdi-check mdi-18px</v-icon>
                                  ثبت توضیحات
                                </v-btn>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'address'">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="6">
                        <v-row>
                          <span>نقشه</span>
                          <v-divider class="mt-3 mr-2 ml-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <div id="map">
                              <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 60vh !important" :zoom="zoom"
                                :center="center" :options="mapOptions" @update:center="centerUpdate"
                                @update:zoom="zoomUpdate" @ready="mapInvalidate()">
                                <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                                <l-control position="bottomleft">
                                  <v-btn small rounded dark color="darkColor" class="no-letter-space"
                                    @click="showLine()">
                                    مشاهده مسیر
                                  </v-btn>
                                </l-control>
                                <!--  -->
                                <!-- <l-control position="topright" v-show="hasNewLocation">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon small tile v-bind="attrs" v-on="on" class="no-letter-space"
                                        @click="backToMainPosition()" style="
                                          background-color: white;
                                          border: solid;
                                          border-width: 2px;
                                          border-radius: 5px;
                                          border-color: #c2bfba;
                                          padding: 15px;
                                        ">
                                        <v-icon>mdi-arrow-u-up-left</v-icon>
                                      </v-btn>
                                    </template>
<span>بازگشت به موقعیت ابتدایی</span>
</v-tooltip>
</l-control>
<l-control position="bottomright" v-show="hasNewLocation">
  <v-btn small rounded dark color="darkColor" class="no-letter-space" @click="sendPationtNewLocationFunction()">
    تغییر موقعیت
  </v-btn>
</l-control> -->
                                <!-- path-markers -->
                                <l-marker v-if="currentZoom > 14" v-for="(item, index) in pathsList" :key="index"
                                  :lat-lng="[item.latitude, item.longitude]" :icon="getPathsIcon(item)">
                                  <l-popup>
                                    <section>
                                      <div class="flex-gap-1">
                                        <div>تاریخ و زمان :</div>
                                        <div>
                                          {{ getCurrentLocationTime(item?.date) }}
                                        </div>
                                      </div>
                                      <div class="flex-gap-1">
                                        <div>سرعت :‌</div>
                                        <div>KM/h</div>
                                        <div>
                                          {{ item?.speed.toFixed(2) }}
                                        </div>
                                      </div>
                                      <div class="flex-gap-1">
                                        <div>وضعیت :</div>
                                        <div>
                                          {{ item?.state ?? 'ندارد' }}
                                        </div>
                                      </div>
                                    </section>
                                  </l-popup>
                                </l-marker>
                                <!-- end l-marker paths -->
                                <l-marker ref="marker" v-if="phoneOnlineLocation?.latitude" :lat-lng="[
                                  phoneOnlineLocation.latitude,
                                  phoneOnlineLocation.longitude,
                                ]" :icon="getMovingIcon(phoneOnlineLocation)">
                                  <l-popup ref="popup">
                                    {{ phoneOnlineLocation?.phone?.code }}
                                  </l-popup>
                                </l-marker>
                                <l-marker v-if="
                                  patiantPosition && patiantPosition.lat && patiantPosition.lng
                                " visible :icon="icon" :lat-lng.sync="patiantPosition" @dragstart="dragingStart"
                                  @dragend="dragging = false" draggable></l-marker>
                                <l-marker v-if="
                                  confirmationLocation &&
                                  confirmationLocation?.lat & confirmationLocation?.lng
                                " :icon="confirmationIcon" :lat-lng.sync="confirmationLocation"></l-marker>
                              </l-map>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row>
                          <span>سابقه آدرس</span>
                          <v-divider class="mt-3 mr-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <edit-dialog-information-component v-if="editTab == 'address'"
                              :tableHeader="addressDataTableHeader" :tableItems="addressDataTableItems"
                              :height="'25vh'"></edit-dialog-information-component>
                          </v-col>
                        </v-row>
                        <v-row>
                          <span>سابقه موقعیت جغرافیایی</span>
                          <v-divider class="mt-3 mr-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <edit-dialog-information-component v-if="editTab == 'address'"
                              :tableHeader="locationConfiramtionTableHeader" :tableItems="missionConfirmations"
                              :height="'25vh'" @rowClick="showConfirmationLocation"
                              class="location-table"></edit-dialog-information-component>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'doctor'">
                <v-row>
                  <v-col class="doctor-part" cols="12" v-for="item in allDoctorOrders" :key="item.id">
                    <v-row class="mt-1">
                      <span class="mr-4">{{ item.patient }}</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorInfoDataTableHeader"
                          :tableItems="item.doctorInfoDataTableItems"
                          :height="'10vh'"></edit-dialog-information-component>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorDrugDataTableHeader"
                          :tableItems="item.doctorDrugDataTableItems"
                          :height="'30vh'"></edit-dialog-information-component>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorOrderDataTableHeader"
                          :tableItems="item.doctorOrderDataTableItems"
                          :height="'30vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'moreInfo'" class="moreInfoBox">
                <v-row>
                  <v-col class="my-5" cols="12">
                    <v-row>
                      <span class="mr-4">اطلاعات پذیرش</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col class="moreInfo-part1" cols="12">
                    <v-row>
                      <v-col cols="12" class="mt-1">
                        <edit-dialog-information-component :tableHeader="admissionDataTableHeader"
                          :tableItems="admissionDataTableItems" :height="'20vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="my-5" cols="12">
                    <v-row>
                      <span class="mr-4">ماموریت های پیوست شده</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col class="moreInfo-part" cols="12">
                    <v-row>
                      <v-col cols="12" class="mt-1">
                        <v-data-table :headers="missionAttachDetailDataTableHeader"
                          :items="missionAttachDetailDataTableItems"
                          :items-per-page="missionAttachDetailDataTableItems.length" max-height="23vh"
                          :hide-default-footer="true" dense class="elevation-0 state-tabel tt table">
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                          <template v-slot:[`item.otherPhoneNumber`]="{ item }">
                            <v-tooltip v-if="item.otherPhoneNumber != '-'" top>
                              <template v-slot:activator="{ on }">
                                <div class="itemCallPhone" v-on="on" @click="callToPatient(item.otherPhoneNumber)">
                                  {{ item.otherPhoneNumber }}
                                </div>
                              </template>
                              <span>تماس با {{ item.otherPhoneNumber }}</span>
                            </v-tooltip>
                            <div v-else class="itemCallPhone" v-on="on">
                              {{ item.otherPhoneNumber }}
                            </div>
                          </template>
                          <template v-slot:[`item.callerId`]="{ item }">
                            <v-tooltip v-if="item.callerId != '-'" top>
                              <template v-slot:activator="{ on }">
                                <div class="itemCallPhone" v-on="on" @click="callToPatient(item.callerId)">
                                  {{ item.callerId }}
                                </div>
                              </template>
                              <span>تماس با {{ item.callerId }}</span>
                            </v-tooltip>
                            <div v-else class="itemCallPhone" v-on="on">
                              {{ item.callerId }}
                            </div>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControl, LPopup } from 'vue2-leaflet';
import 'leaflet-ant-path';
import 'leaflet/dist/leaflet.css';
import Vue from 'vue';
import confirmDialog from '@/components/ConfirmDialog.vue';
import UserDetailComponent from '../UserDetailComponentNew.vue';
import EditDialogInformationComponent from '../115/EditDialogInformationComponent.vue';
import DispatchNoteComponent from '@/components/800/DispatchNoteComponent.vue';
import snackBar from '@/Mixins/snackBar.js';
import SharedMixin from '@/Mixins/Shared';
import SharedHelper from '@/Helpers/Shared';
import TagMixin from '@/Mixins/BaseInformation/TagMixin';
import CityMixin from '@/Mixins/BaseInformation/CityMixin';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
import missionStateMixin from '@/Mixins/Mission/MissionStateMixin';
import MissionTranform from '@/Helpers/800/mission.transform';
import missionNoteMixin from '@/Mixins/Mission/MissionNoteMixin';
import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import SharedMap from '@/Mixins/map';
import DispatchCodeMixin from '@/Mixins/BaseInformation/DispatchCodeMixin';
import StationMixin from '@/Mixins/BaseInformation/StationMixin';
import MissionAddressLogMixin from '@/Mixins/Mission/MissionAddressLogMixin';
import MissionMixin from '@/Mixins/Mission/MissionMixin';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin';
import PatientDoctorDetailMixin from '@/Mixins/Doctor/PatientDoctorDetailMixin';
import CallMixin from '@/Mixins/Call/CallMixin';
import missionOtherOrganizationRequestMixin from '@/Mixins/Mission/MissionOtherOrganizationRequestMixin.js';
import missionOtherOrganizationInformMixin from '@/Mixins/Mission/MissionOtherOrganizationInformMixin.js';
import OtherOrganizationMixin from '@/Mixins/BaseInformation/OtherOrganizationMixin';
import GeographicalTypeMixin from '@/Mixins/BaseInformation/GeographicalTypeMixin';
import Edit800MissionHelper from '@/Helpers/800/Edit800MissionHelper.js';
export default {
  name: 'Edit800Mission',
  title: 'اطلاعات ماموریت',
  inject: ['load'],
  components: {
    UserDetailComponent,
    EditDialogInformationComponent,
    confirmDialog,
    DispatchNoteComponent,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPopup,
  },
  mixins: [
    Edit800MissionHelper,
    snackBar,
    SharedMixin,
    TagMixin,
    CityMixin,
    MissionPhonesMixin,
    missionStateMixin,
    missionNoteMixin,
    HospitalMixin,
    ZoneMixin,
    DispatchCodeMixin,
    StationMixin,
    MissionAddressLogMixin,
    MissionMixin,
    PhoneOnlineLocationMixin,
    PatientDoctorDetailMixin,
    CallMixin,
    missionOtherOrganizationRequestMixin,
    missionOtherOrganizationInformMixin,
    OtherOrganizationMixin,
    GeographicalTypeMixin,
    SharedHelper,
    MissionTranform,
    SharedMap,
  ],
  created() {
    this.$root.$refs.Edit800Mission = this;
  },
  mounted() {
    this.mounteLoding();
  },
  props: {
    missionId: {
      type: Number,
      require: true,
      default: null,
    },
    missionPhoneId: {
      type: Number,
      require: true,
      default: null,
    },
    missionCode: {
      type: String,
      require: true,
    },
    phoneCode: {
      type: String,
      require: true,
    },
    phoneId: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      zoom: 12,
      center: latLng(30.2839, 57.0834),
      mapTileUrl: '',
      attribution: '&copy; Asemantech',
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      patiantPosition: {},
      confirmationLocation: {},
      mainPationtPosition: {},
      dragging: false,
      icon: L.icon({
        iconUrl: require('@/assets/images/patient-location.svg'),
        iconSize: [35, 35],
      }),
      hasNewLocation: false,
      stoppedVehicleIcon: require('@/assets/images/stop_icon.svg'),
      confirmationIcon: L.icon({
        iconUrl: require('@/assets/images/patient-location-history-icon.svg'),
        iconSize: [35, 35],
      }),
    };
  },
  methods: {
    handleEnterLack() {
      this.$nextTick(() => {
        if (this.selectedMissionLakeCode) {
          this.addMissionLakeCode();
        }
      });
    },
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      clearInterval(this.mapSingleMovingIconInterval);
      this.getListOfDispatchCodesForOther();
      this.getListOfCitysForOther();
      this.getAllZones();
      this.getListOfStationsForOther();
      this.getAllGeographicalTypes();
      this.getMissionConfirmationFunction(this.missionId);
      this.setMapBaseSystemSetting();
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
        this.$refs.modalmap?.mapObject?.flyTo(
          [this.patiantPosition?.lat, this.patiantPosition?.lng],
          16,
        );
      }, 100);
      setTimeout(() => {
        this.$refs?.marker?.mapObject?.openPopup();
      }, 300);
    },
    getMovingIcon(data) {
      if (data.isPhoneLocation == true) {
        //is phone
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      } else if (data.isPhoneLocation == false) {
        //is gps
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      }
    },
    getCurrentLocationTime: function (date) {
      return Vue.moment(date).format('jYYYY/jMM/jDD-HH:mm:ss');
    },
    showConfirmationLocation: function (item) {
      this.confirmationLocation = {
        lat: item.lat,
        lng: item.lng,
      };
      this.confirmationLocation = latLng(item?.latitude, item?.longitude);
    },
    getPathsIcon(data) {
      if (data?.speed > 3) {
        const iconImg = this.movingIconForGPSWithMission;
        return L.divIcon({
          className: 'my-custom-pin',
          html: `<img src="${iconImg}" style="width:15px; height:15px; transform:rotate(${data.bearing}deg)"/>`,
        });
      }
      const iconImg = this.stoppedVehicleIcon;
      return L.divIcon({
        className: 'my-custom-pin',
        html: `<img src="${iconImg}" style="width:30px; height:30px;transform:translateY(-160%)"/>`,
        iconAnchor: [-15, -45],
      });
    },
    ShowAntPath(latLngs) {
      const antPath = L.polyline.antPath(latLngs);
      antPath.addTo(this.$refs.modalmap.mapObject);
    },
    backToMainPosition: function () {
      this.patiantPosition = {
        lat: this.mainPationtPosition.lat,
        lng: this.mainPationtPosition.lng,
      };
      this.hasNewLocation = false;
    },
    dragingStart: function () {
      this.dragging = true;
      this.hasNewLocation = true;
    },
  },
  watch: {
    missionInformation: function (newVal) {
      if (newVal.dispatchCurrentState === '10-19') {
        this.wasDispatchState1019 = true;
        // this.editMissionTenNineteenNote='10-19';
      }
      if (newVal.allow1019) this.was1019 = true;
    },

    // was1019:function(newVal){
    //   if(!newVal&&!this.editMissionTenNineteenNote&&(this.missionInformation.allow1019||this.missionInformation.dispatchCurrentState==='10-19')){
    //   }
    // }
    // 'missionInformation.dispatchCurrentState':function(newVal){
    //   if(newVal==='10-19'&&!this.editMissionTenNineteenNote){
    //     this.showTenNineteenModal();

    //     }
    // },
  },
  beforeDestroy() {
    try {
      this.clearSetIntrvals();
    } catch (error) {
      console.log("A error:", error);
    }
  },
};
</script>
<style lang="scss">
.location-table td {
  cursor: pointer !important;
}
</style>
<style scoped>
.itemCallPhone {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  color: var(--dark-color);
}

.itemCallPhone:hover {
  background: #acacac;
}

.brnAction {
  min-width: 30px !important;
  width: 32px;
  margin: auto !important;
}

.menu-top-items {
  cursor: pointer !important;
}

.active-tab {
  color: var(--dark-color) !important;
  background: var(--background-color) !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border-radius: 5px !important;
}

.edit-modal-phones-card {
  max-height: 200px;
  overflow-y: auto;
}

.edit-modal-card-detail {
  border-radius: 12px !important;
  border: 1px solid var(--dark-color) !important;
}

.modal-title-text-menu {
  cursor: pointer;
}

.phone-numbers-items {
  background: var(--background-color) !important;
  border-radius: 5px !important;
  padding-right: 15px !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.phone-numbers-items-icon {
  background: var(--dark-color) !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  border-radius: 5px !important;
}

.edit-mission-main-card {
  overflow-y: auto;
  min-height: 525px;
  max-height: 90vh;
}

.note-box {
  border: 1px solid #909090 !important;
  border-radius: 12px !important;
}

.not-box-title {
  position: absolute;
  background: white;
  padding-right: 20px !important;
  margin-top: -1.4vh !important;
  margin-right: 45px !important;
}

.note-box-input {
  margin-top: 2.5vh !important;
}

.note-component-space {
  height: 47vh !important;
  overflow-y: auto !important;
}

.phone-code {
  color: var(--dark-color);
  margin-right: 5px !important;
}

.doctor-part {
  height: 68vh;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.moreInfo-part {
  height: 25vh;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.moreInfo-part1 {
  height: 22vh;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.other-organ-selected-card-part {
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.other-organ-sugest-card-part {
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
}

.other-organ-sugest-user {
  position: absolute;
  margin-top: -12px;
  margin-right: 24px;
  padding-left: 8px;
  padding-right: 5px;
  background: white;
  font-size: 12px;
}

.other-organ-selected-span {
  background: var(--background-color) !important;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 30px !important;
  font-size: 12px;
}
</style>

<style lang="scss">
.state-tabel {
  overflow: hidden;
}

.table thead {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
<style scoped>
>>>.v-data-table-header {
  background: var(--dark-color) !important;
}

>>>.state-tabel thead th:first-child {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

>>>.state-tabel thead th:last-child {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}

>>>.v-data-table-header tr th span {
  color: white !important;
}

>>>.state-tabel {
  border: 1px solid var(--light-color) !important;
  border-radius: 8px !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
